import { render, staticRenderFns } from "./ak3.vue?vue&type=template&id=48024a76"
import script from "./ak3.vue?vue&type=script&lang=js"
export * from "./ak3.vue?vue&type=script&lang=js"
import style0 from "./ak3.vue?vue&type=style&index=0&id=48024a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports